"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UIUtil = void 0;
class UIUtil {
    static doesElementExist(selector) {
        return document.querySelector(selector) !== null;
    }
    static waitForElementToExist(selector, delay, maxAttempts, successCallback, errorCallback, attemptCallback) {
        //const el = document.querySelector(selector) !== null;
        let attempts = 0;
        const tryFindingElement = () => {
            const element = document.querySelector(selector);
            if (element) {
                successCallback();
            }
            else {
                attempts++;
                if (attempts >= maxAttempts) {
                    errorCallback();
                }
                else {
                    if (attemptCallback) {
                        attemptCallback(attempts);
                    }
                    setTimeout(tryFindingElement, delay);
                }
            }
        };
        tryFindingElement();
    }
    static registerDynamicClickEvent(selector, callback, parent = document.body, 
    // Listen in the capture phase by default so the delegated handler runs on the way
    // down to the target, before any descendant's bubble-phase stopPropagation() can
    // swallow the click (e.g. theme/menu JS). event.target is already correct in capture,
    // so the walk-up-and-match logic below is unaffected.
    useCapture = true) {
        const handleClick = function (event) {
            let target = event.target;
            // Traverse up the DOM tree until we find an element matching our selector or reach the parent
            while (target && target !== parent) {
                if (target.matches(selector)) {
                    event.preventDefault();
                    callback(event, target);
                    return;
                }
                target = target.parentElement;
            }
        };
        // Use event delegation by attaching the listener to a parent element that exists now
        parent.addEventListener('click', handleClick, useCapture);
        return function removeListener() {
            parent.removeEventListener('click', handleClick, useCapture);
        };
    }
    static registerDynamicFormSubmitEvent(selector, callback, parent = document.body) {
        const handleSubmit = function (event) {
            let target = event.target;
            while (target && target !== parent) {
                if (target.matches(selector) && target instanceof HTMLFormElement) {
                    event.preventDefault();
                    callback(event, target);
                    return;
                }
                target = target.parentElement;
            }
        };
        parent.addEventListener('submit', handleSubmit);
        // Return a function that can be called to remove the event listener
        return function removeListener() {
            this.Logger.trace("Removing submit event listener");
            parent.removeEventListener('submit', handleSubmit);
        };
    }
    static addToEndOfBody(html) {
        document.body.insertAdjacentHTML('beforeend', html);
    }
    static trySetInnerHTML(selector, html) {
        const element = document.querySelector(selector);
        if (element) {
            element.innerHTML = html;
            return true;
        }
        else {
            return false;
        }
    }
}
exports.UIUtil = UIUtil;
